const SpecialFiledValue = {
  NOT_AVAILABLE: "-",
};

export default SpecialFiledValue;
